import { Box } from '@mui/material';
import { ModalV2 } from '../../shared/modal/modal';
import { NormalText } from '../../shared/styles';
import { deleteContactAgenda } from '../../redux/actions/agenda.actions';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useState } from 'react';

export const ModalDeleteContact = ({
  open,
  handleClose,
  idContact,
  userId,
}) => {
  const dispatch = useDispatch();
  const [isDeleting, setIsDeleting] = useState(false);

  async function handleDeleteContact() {
    if (isDeleting) return;
    setIsDeleting(true);
    const result = await dispatch(deleteContactAgenda(idContact, userId));
    setIsDeleting(false);

    if (result?.success) {
      toast.success('Contact deleted');
      handleClose('deleteContact');
    } else {
      toast.error(result?.message || 'Could not delete contact');
    }
  }

  return (
    <ModalV2
      isOpen={open}
      title={'Delete contact'}
      handleClose={() => handleClose('deleteContact')}
      actionButtons={[
        {
          label: 'Cancel',
          onClick: () => handleClose('deleteContact'),
        },
        {
          label: 'Delete',
          onClick: handleDeleteContact,
          disabled: isDeleting,
        },
      ]}
    >
      <Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          gap={'8px'}
          px={'24px'}
          pb={'24px'}
        >
          <NormalText>Are you sure you want to delete this contact?</NormalText>
        </Box>
      </Box>
    </ModalV2>
  );
};
